import React from 'react'
import { TrackEvent, useTracking } from '../../common/tracking'
import { getRoomTrackingDetails } from '../../tracking'
import { useAppSelector } from '../../../../../store/hooks'
import { selectRoomSession } from '../../../../../store/meetingSummary/roomSession'
import './Chat.scss'
import { StreamingAIAgentChat } from '../../../../../views/AIAgent/Chat/StreamingAIAgentChat'

export interface ChatProps {
  isLoading: boolean
  interactionIsLoading: boolean
  disabled: boolean
  onMeetingPrepChatInteraction: (chatMessage: string) => void
  handleResubmitInteraction: () => Promise<void>
}

export const Chat: React.FC<ChatProps> = ({ isLoading, interactionIsLoading, disabled, onMeetingPrepChatInteraction, handleResubmitInteraction }) => {
  const { tracked } = useTracking()
  const roomSession = useAppSelector(selectRoomSession)

  const handleChatInteraction = tracked(
    onMeetingPrepChatInteraction,
    {
      eventName: TrackEvent.MEETING_PREP_INTERACTED_WITH,
      eventDetails: { ...getRoomTrackingDetails(roomSession), source: roomSession?.isActive ? 'live' : 'upcoming', type: 'chat' },
    },
    {
      eventDetailsExtractor: (chatMessage: string) => ({
        chatMessage,
      }),
    },
  )

  return (
    <div className='chat-container'>
      <StreamingAIAgentChat
        handleSubmit={handleChatInteraction}
        isLoading={interactionIsLoading}
        disabled={interactionIsLoading || isLoading || disabled}
        collapsible={true}
        handleResubmit={handleResubmitInteraction}
      />
    </div>
  )
}
